import { render, staticRenderFns } from "./tab-bar-demo.vue?vue&type=template&id=3d71633f"
import script from "./tab-bar-demo.vue?vue&type=script&lang=js"
export * from "./tab-bar-demo.vue?vue&type=script&lang=js"
import style0 from "./tab-bar-demo.vue?vue&type=style&index=0&id=3d71633f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports